import { css } from '@emotion/react';
import { atoms, Link } from '@zapier/marketing-ui';

type Props = {
  email: string;
  onClear: () => void;
};

const rootClass = `${atoms.bodySM} ${atoms.fontSemibold} ${atoms.textCenter} ${atoms.textNeutral900}`;
const linkStyle = css`
  white-space: nowrap;
`;

export function WelcomeBackMessage({ email, onClear }: Props) {
  if (email) {
    return (
      <p className={`${rootClass} fs-exclude`}>
        Welcome back {email}!{' '}
        <span css={linkStyle}>
          <Link onClick={onClear}>Not you?</Link>
        </span>
      </p>
    );
  }

  return <p className={rootClass}>Welcome back!</p>;
}
